import { Component, OnInit, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { KycMarutiJourneyService } from './kyc-maruti-journey.service';
import { HypervergeTokenRes } from './kyc-maruti-journey-model';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { Subject, fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { KycResultResponse, KycSearchRequest } from '../kyc-hyperverge/kyc-hyperverge.model';
import { KycResultsAPIReq } from '../kyc-link-results/kyc-link-results.model';
import { KycHypervergeService } from '../kyc-hyperverge/kyc-hyperverge.service';

@Component({
  selector: 'app-kyc-maruti-journey',
  templateUrl: './kyc-maruti-journey.component.html',
  styleUrls: ['./kyc-maruti-journey.component.css']
})
export class KycMarutiJourneyComponent implements OnInit {

  isLoading: boolean;
  flowType: string;
  kycUniqueId: string;
  currentDate: Date;
  accessToken: string;
  error: string;
  kycDetails: any;
  urlType: string;
  identifier: string;
  linkDetails: any;
  customerType: string;
  appName: string;
  returnUrl: string;
  empCode: string;
  empName: string;
  empDesignation: string;
  panValue: string;
  //panMadatory: boolean = false;
  form60: string;
  isExternalUser: string;
  customerName: string;
  kycReferenceNo: string;
  private unsubscriber: Subject<void> = new Subject<void>();
  kycSearchRequest: KycSearchRequest = new KycSearchRequest();
  identifierOrg: any;
  kycResultsAPIRes: KycResultResponse;
  showPartnerportal: boolean =false;
  isShow: boolean = true;

  constructor(private renderer2: Renderer2, @Inject(DOCUMENT) private _document, private kycMarutiService: KycMarutiJourneyService, private route: ActivatedRoute, private location: LocationStrategy,private router: Router,public kycHypervergeService: KycHypervergeService) {
    this.kycSearchRequest = new KycSearchRequest();
    this.kycResultsAPIRes = new KycResultResponse();
  }

  ngOnInit(): void {
    //history.pushState(null, '');

    /*fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });*/
    this.route.queryParams.subscribe(
      (params: Params) => {
        if (params['identifier']) {
          this.identifierOrg = params['identifier'];
          this.identifier = atob(params['identifier']);
        }
      }
    );
    if(this.identifier) {
      this.linkDetails = JSON.parse(this.identifier);
      this.kycUniqueId = this.linkDetails.uniqueId;
      this.urlType = this.linkDetails.urlType;
      this.customerType = this.returnCustomerType(this.linkDetails.customerType);
      this.appName = this.linkDetails.appName;
      this.returnUrl = this.linkDetails.returnUrl;
      this.empCode = this.linkDetails.empCode;
      this.empName = this.linkDetails.empName;
      this.empDesignation = this.linkDetails.empDesignation;
      this.panValue = this.linkDetails.panNo;
      this.form60 = this.linkDetails.form60;
      this.customerName = this.linkDetails.customerName;
      this.isExternalUser = this.linkDetails.isExternalUser;
      this.kycReferenceNo = this.linkDetails.kycReferenceNo;
    }
    if(this.kycUniqueId && this.kycUniqueId.substring(0,3).startsWith('KY3')) {
      this.showPartnerportal = true;
    } else {
      this.showPartnerportal = false;
    }
    this.kycResultDetails();
    /*const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.src = "https://hv-camera-web-sg.s3-ap-southeast-1.amazonaws.com/hyperverge-web-sdk@5.6.0/src/sdk.min.js";
    s.text = ``;
    this.renderer2.appendChild(this._document.body, s);
    sessionStorage.setItem('uniqueId', this.kycUniqueId);
    sessionStorage.setItem('customerType', this.customerType);
    sessionStorage.setItem('appName',this.appName);
    sessionStorage.setItem('returnUrl',this.returnUrl);
    sessionStorage.setItem('kycReferenceNo', this.kycReferenceNo);*/
  }

  returnCustomerType(custType) {
    let customerType: string = "";
    if(custType == 'C' || custType == 'Corporate' || custType == 'CorporateCustomer') {
      customerType = "Corporate";
    } else if(custType == 'I' || custType == 'Individual' || custType == 'IndividualCustomer' ) {
      customerType = "Individual";
    } else {
      customerType = custType;
    }
    return customerType;
  }

  kycResultDetails() {
    let body = {
      "uniqueId": this.kycUniqueId
    }
    this.isLoading = true;
    this.kycHypervergeService.getKycStatusResults(body).subscribe((data: any) => {
      this.isLoading = false;
      this.kycResultsAPIRes = JSON.parse(JSON.stringify(data));
      if(this.kycResultsAPIRes.applicationStatus != 'auto_approved' &&  this.kycResultsAPIRes.applicationStatus != 'manually_approved' && this.kycResultsAPIRes.applicationStatus != 'success' && this.kycResultsAPIRes.applicationStatus != 'Success') {
        this.isShow = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  startKyc(value) {
    this.kycDetails = null;
    if (!this.kycUniqueId) {
      this.getUniqueId();
    }
    this.flowType = value;

    if(this.flowType == 'ckycFlow'){
      this.router.navigate(['/ckyc-maruti-documents'], { queryParams: { 'identifier': this.identifierOrg } });
    }else{
      this.router.navigate(['/manualkyc-maruti-documents'], { queryParams: { 'identifier': this.identifierOrg } })
    }
  }

  getUniqueId() {
    this.currentDate = new Date();
    this.kycUniqueId = "MI" + this.currentDate.getFullYear().toString() + this.currentDate.getMonth().toString() + this.currentDate.getDate().toString() + this.currentDate.getHours().toString() + this.currentDate.getMinutes().toString() + this.currentDate.getSeconds().toString() + this.currentDate.getMilliseconds().toString();
  }

  goToBackPage() {
    this.isLoading = true;
    window.location.href = this.returnUrl;
  }
}
